<template>
    <div class="my-referral-stat">
        <span class="my-referral-stat__value">
            <slot name="value"></slot>
        </span>
        <span class="my-referral-stat__caption">
            <slot name="caption"></slot>
        </span>
    </div>
</template>